import Vue from 'vue';

function initialState() {
  return {
    UI_SearchResults: [],
    UI_ActivePlatforms: [],
    Current_UI_Page: 0,
    UI_UserList: [],
    UI_UsersCount: 0,
    UI_SelectedSize: 25
  };
}

var state = initialState();

const actions = {

  search_UI_Accounts: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http.get('platform/searchdealers?accountId=' + param.accountId + '&term=' + param.searchTxt + '&internalOnly=' + param.interalOnly).then(function (data) {
        data.data.Data.forEach(function (account) {
          account.LabelText = account.Account + " [" + account.AccountId + "]";
        });
        context.commit('Update_UI_SearchResults', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  load_UI_ActiveDealers: function (context, accountId) {
    return new Promise((resolve, reject) => {
      Vue.http.get('account/platforms/' + accountId).then(function (data) {
        context.commit('Update_UI_ActivePlatforms', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  filterUsers: function (context, query) {
    return new Promise((resolve, reject) => {
      Vue.http.get('core/userintegrity/report' + query).then(function (data) {
        context.commit('UpdateUI_UserList', data.data.Data);
        context.commit('Update_UI_TotalCount', data.data.TotalCount);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  FixUserRecord: function (context, params) {
    return new Promise((resolve, reject) => {
      Vue.http.post('core/userintegrity/fix', params).then(function (data) {
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  UpdateCurrent_UI_Page: function (context, page) {
    context.commit('UpdateCurrent_UI_Page', page);
  },
  UpdateUI_UserList: function (context, data) {
    context.commit('UpdateUI_UserList', data);
  },
  UpdateUI_UserCount: function (context, data) {
    context.commit('Update_UI_TotalCount', data);
  },
  UpdateCurrent_UI_PageSize: function (context, data) {
    context.commit('UpdateCurrent_UI_PageSize', data);
  }

}

const mutations = {

  Update_UI_SearchResults: function (state, data) {
    state.UI_SearchResults = data;
  },
  Update_UI_ActivePlatforms: function (state, data) {
    state.UI_ActivePlatforms = data;
  },
  UpdateCurrent_UI_Page: function (state, data) {
    state.Current_UI_Page = data;
  },
  UpdateUI_UserList: function (state, data) {
    state.UI_UserList = data;
  },
  Update_UI_TotalCount: function (state, data) {
    let currentsize = state.UI_SelectedSize ? state.UI_SelectedSize : 25;
    let count = data / currentsize;
    state.UI_UsersCount = Math.ceil(count);
  },
  UpdateCurrent_UI_PageSize: function (state, data) {
    state.UI_SelectedSize = data;
  }
  
}

const getters = {
  UI_SearchResults: function () {
    return state.UI_SearchResults
  },
  UI_ActivePlatforms: function () {
    return state.UI_ActivePlatforms;
  },
  Current_UI_Page: function () {
    return state.Current_UI_Page;
  },
  UI_UserList: function () {
    return state.UI_UserList;
  },
  UI_UsersCount: function () {
    return state.UI_UsersCount;
  },
  UI_SelectedSize: function () {
    return state.UI_SelectedSize;
  }


}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users/UserIntegrity.js